import { Box, Flex, Image, useBreakpointValue } from "@chakra-ui/react";
import gradeBg from "@/assets/images/grades_banner.png";
import gradeImg from "@/assets/images/gradeimg.png";

const Grades = () => {
  const fontSize1 = useBreakpointValue({
    base: '14px', 
    md: '18px', 
    lg: '22px',  
  });
  
  return (
    <Box overflow={"hidden"}>
      <Box width="80%" m="0 auto">
        <Box
          mt="40px"
          mb="20px"
          color="#27314D"
          fontWeight="bold"
          fontSize="24px"
        >
          等级和勋章
        </Box>
        <Flex
          h="149px"
          position={"relative"}
          bg={`url('${gradeBg}')`}
          backgroundSize="cover"
          backgroundPosition="top center"
          bgRepeat={"no-repeat"}
          alignItems="center"
        >
          <Box w="60%" p="20px" color={"#27314D"} fontSize={fontSize1}>等级和勋章是为用户提供的一项增值服务，包含多项专属权益、福利赠送，更多权益策略还在不断完善中，敬请期待。</Box>
        </Flex>
        <Box mt="40px" color={"#27314D"} fontSize="18px" fontWeight={"bold"}>
          部分效果预展示
        </Box>
        <Flex mt="35px" mb="60px" justifyContent={"center"}>
          <Image src={gradeImg} />
        </Flex>
      </Box>
    </Box>
  );
};

export default Grades;
